import "./buttons.css";
import { Link } from "react-router-dom";

const primaryButton = (props) => {
  return (
    <div className="button primary-btn">
      <Link to="/#" className="link">
        {props.children}
      </Link>
    </div>
  );
};

const secondaryButton = (props) => {
  return (
    <div className="button secondary-btn">
      <Link to="/#" className="link">
        {props.children}
      </Link>
    </div>
  );
};

export default primaryButton;
export { secondaryButton };
